/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */

/**
 * Approval status for absences
 */
export type FacilityFlowCoreModulesPlanningEntitiesApprovalStatus = typeof FacilityFlowCoreModulesPlanningEntitiesApprovalStatus[keyof typeof FacilityFlowCoreModulesPlanningEntitiesApprovalStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FacilityFlowCoreModulesPlanningEntitiesApprovalStatus = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
} as const;
